const graphAPIEndpoints = {
  ethereum: {
    metaverse: null,
    shibaswap: 'https://swap-eth-ex-prod-subsquid.shib.io/graphql',
  },
  puppynet: {
    metaverse: null,
    shibaswap: 'https://swap-eth-ex-prod-subsquid.shib.io/graphql',
  },
  shibarium: {
    metaverse: null,
    shibaswap: 'https://swap-eth-ex-prod-subsquid.shib.io/graphql',
  },
  multichain: {
    metaverse: 'https://shib.squids.live/shib-metaverse@main/api/graphql',
  },
};

export default graphAPIEndpoints;
